// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falAlignJustify: CreateIconOptions = {
  "displayName": "FALAlignJustify",
  "viewBox": "0, 0, 448, 512",
  "d": "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zM0 192c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16zM16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
};
